"use client";

import { c as _c } from "react/compiler-runtime";
import "video.js/dist/video-js.css";
import { useEscapeKey } from "@/hooks/useEscapeKey";
import { useTrailerPlayer } from "./trailer/useTrailerPlayer";
import { TrailerCover, TrailerLoading, TrailerError } from "./trailer/TrailerOverlays";
interface Props {
  open: boolean;
  trailerUuid: string;
  onClose: () => void;
}
export default function TrailerModal(t0) {
  const $ = _c(31);
  const {
    open,
    trailerUuid,
    onClose
  } = t0;
  let t1;
  if ($[0] !== open || $[1] !== trailerUuid) {
    t1 = {
      open,
      trailerUuid
    };
    $[0] = open;
    $[1] = trailerUuid;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    videoRef,
    loading,
    error,
    ready,
    retry
  } = useTrailerPlayer(t1);
  useEscapeKey(open, onClose);
  if (!open) {
    return null;
  }
  let t2;
  if ($[3] !== onClose) {
    t2 = e => {
      if (e.target === e.currentTarget) {
        onClose();
      }
    };
    $[3] = onClose;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div style={{
      paddingBottom: "56.25%"
    }} />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      width: "100%",
      height: "100%"
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== videoRef) {
    t5 = <div data-vjs-player={true} className="w-full h-full"><video ref={videoRef} className="video-js vjs-big-play-centered vjs-default-skin" style={t4} /></div>;
    $[7] = videoRef;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== ready) {
    t6 = <TrailerCover ready={ready} />;
    $[9] = ready;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== error || $[12] !== loading) {
    t7 = loading && !error && <TrailerLoading />;
    $[11] = error;
    $[12] = loading;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== error || $[15] !== loading || $[16] !== retry) {
    t8 = error && !loading && <TrailerError message={error} onRetry={retry} />;
    $[14] = error;
    $[15] = loading;
    $[16] = retry;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t5 || $[19] !== t6 || $[20] !== t7 || $[21] !== t8) {
    t9 = <div className="absolute inset-0">{t5}{t6}{t7}{t8}</div>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== onClose) {
    t10 = <button onClick={onClose} className="absolute right-3 top-3 z-20 flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white transition hover:bg-white/20">✕</button>;
    $[23] = onClose;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t9) {
    t11 = <div className="relative w-full max-w-5xl bg-black rounded-2xl overflow-hidden">{t3}{t9}{t10}</div>;
    $[25] = t10;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t11 || $[29] !== t2) {
    t12 = <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-md p-4" onClick={t2}>{t11}</div>;
    $[28] = t11;
    $[29] = t2;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  return t12;
}